module.exports = __webpack_public_path__ + "static/media/nexceris-city-art.58ef186f.png";